<div class="cadastro-responsavel-container">
  <div class="header">
    <h1><i class="fas fa-user-tie"></i> Cadastro de Responsável</h1>
    <button type="button" class="btn btn-primary" (click)="abrirModalCadastro(modalCadastro)">
      <i class="fa fa-plus"></i> Novo responsável
    </button>
  </div>

  <div class="card-box mb-3">
    <div class="row g-3 align-items-end">
      <div class="col-md-9">
        <label class="form-label">Filtro</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="filtroTexto"
          (keyup)="aplicarFiltros()"
          placeholder="Pesquisar por responsável ou sigla..." />
      </div>
      <div class="col-md-3 d-grid">
        <button type="button" class="btn btn-outline-secondary" (click)="limparFiltros()">
          <i class="fa fa-times"></i> Limpar
        </button>
      </div>
    </div>
    <p class="reorder-hint mb-0 mt-2" *ngIf="podeReordenar && itens.length > 1">
      <i class="fa fa-arrows-alt-v"></i>
      Arraste pela alça <i class="fa fa-grip-vertical"></i> para alterar a ordem.
      <span class="text-muted" *ngIf="reordenando">Salvando...</span>
    </p>
    <p class="reorder-hint reorder-hint--disabled mb-0 mt-2" *ngIf="!podeReordenar && itens.length > 0">
      <i class="fa fa-info-circle"></i>
      Limpe o filtro para reordenar os responsáveis na tabela.
    </p>
  </div>

  <div class="card-box">
    <div class="table-responsive">
      <table class="table table-hover mb-0" [class.table-reordenavel]="podeReordenar">
        <thead>
          <tr>
            <th style="width: 44px;" *ngIf="podeReordenar"></th>
            <th style="width: 70px;">Ordem</th>
            <th>Responsável</th>
            <th style="width: 140px;">Sigla</th>
            <th style="width: 170px;">Ações</th>
          </tr>
        </thead>
        <tbody
          *ngIf="podeReordenar"
          [dragula]="'cad-responsavel-ordem'"
          [(dragulaModel)]="itens">
          <tr *ngFor="let item of itens" [class.row-reordenando]="reordenando">
            <td class="drag-cell">
              <span class="drag-handle" title="Arraste para reordenar">
                <i class="fa fa-grip-vertical"></i>
              </span>
            </td>
            <td>{{ item.ordem }}</td>
            <td>{{ item.responsavel }}</td>
            <td>{{ item.sigla }}</td>
            <td>
              <button type="button" class="btn btn-sm btn-warning me-1" (click)="abrirModalCadastro(modalCadastro, item)" title="Editar">
                <i class="fa fa-edit"></i>
              </button>
              <button type="button" class="btn btn-sm btn-danger" (click)="excluir(item)" title="Excluir">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="!loading && itens.length === 0">
            <td colspan="5" class="text-center text-muted py-3">Nenhum responsável cadastrado.</td>
          </tr>
        </tbody>
        <tbody *ngIf="!podeReordenar">
          <tr *ngFor="let item of itensPaginados">
            <td>{{ item.ordem }}</td>
            <td>{{ item.responsavel }}</td>
            <td>{{ item.sigla }}</td>
            <td>
              <button type="button" class="btn btn-sm btn-warning me-1" (click)="abrirModalCadastro(modalCadastro, item)" title="Editar">
                <i class="fa fa-edit"></i>
              </button>
              <button type="button" class="btn btn-sm btn-danger" (click)="excluir(item)" title="Excluir">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="!loading && itensFiltrados.length === 0">
            <td colspan="4" class="text-center text-muted py-3">Nenhum responsável cadastrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3" *ngIf="!podeReordenar && itensFiltrados.length > 0">
      <div class="d-flex align-items-center gap-2">
        <label class="mb-0">Itens por página:</label>
        <select class="form-control form-control-sm per-page" [(ngModel)]="itensPorPagina" (change)="alterarItensPorPagina()">
          <option [ngValue]="5">5</option>
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
          <option [ngValue]="50">50</option>
        </select>
      </div>

      <div class="d-flex align-items-center gap-2">
        <span class="text-muted">Página {{ paginaAtual }} de {{ totalPaginas }}</span>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="paginaAnterior()" [disabled]="paginaAtual <= 1">
          Anterior
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="proximaPagina()" [disabled]="paginaAtual >= totalPaginas">
          Próxima
        </button>
      </div>
    </div>
  </div>

  <ng-template #modalCadastro>
    <div class="modal-header">
      <h5 class="modal-title">{{ itemEdicao ? 'Editar responsável' : 'Novo responsável' }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modalRef?.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div class="form-group mb-3">
        <label class="form-label">Responsável *</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="formResponsavel"
          maxlength="255"
          placeholder="Nome do responsável" />
      </div>
      <div class="form-group">
        <label class="form-label">Sigla *</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="formSigla"
          maxlength="20"
          placeholder="Ex.: JR" />
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="modalRef?.dismiss()">Cancelar</button>
      <button type="button" class="btn btn-success" (click)="salvar()" [disabled]="salvando">
        <i class="fa fa-save"></i> {{ itemEdicao ? 'Salvar edição' : 'Salvar novo' }}
      </button>
    </div>
  </ng-template>
</div>
